export enum UserRole {
	SUPER_ADMIN = 'SUPER_ADMIN',
	ADMIN = 'ADMIN',
	DUAL = 'DUAL',
	MANAGER = 'MANAGER',
	TECHNICIAN = 'TECHNICIAN',
}
